import { Comment } from "../../src/components/insta/interfaces";
import { getAlexComments } from "./InstaCommentsAlex";
import { getAnnComments } from "./InstaCommentsAnn";


export function getComments(imageKey: string) {
    const comments: { [key: string]: (Comment)[]; } = {
        ...getAlexComments(imageKey),
        ...getAnnComments(imageKey),

    };

    return comments[imageKey] || [];

}